import { InstanceScreen } from 'component/navigation/instance';
import { LoadingSpinnerContainer } from 'component/progress/loading-spinner';
import { useProfile } from 'data/profile';
import { Stack, useLocalSearchParams } from 'expo-router';

export default function ModerationDashboardUserPostsScreen() {
    const { userKey } = useLocalSearchParams<'/[siloKey]/moderationdash/one/posts/[userKey]'>();
    const { profile } = useProfile(userKey);
    if (!profile) return <LoadingSpinnerContainer />;
    return (
        <>
            <Stack.Screen options={{ title: profile.name }} />
            <InstanceScreen params={{ userKey1: userKey }} screenKey='posts/[userKey]' />
        </>
    );
}
